import React, { useEffect, useState } from "react";
import { useUser } from "../../context/userContext";
import constants from "../../constants/ResponseArea/simulateAutomata";
import "../Simulate/SimulateAutomata.css";

const SimulateAutomata = (props) => {
  const { language } = useUser();
  // const [arrayWordTape, setArrayWordTape] = useState([]);
  const [acceptanceCriteria, setAcceptanceCriteria] = useState("");
  const [arraySymbolsExternAlphabet, setArraySymbolsExternAlphabet] = useState(
    ""
  );

  useEffect(() => {
    let arrayTape = [];
    if (props.response.word != undefined)
      for (let i = 0; i < props.response.word.length; i++) {
        arrayTape.push(props.response.word[i]);
      }
    // setArrayWordTape(arrayTape);
  }, [props.response.word]);

  useEffect(() => {
    const {
      tape,
      finalStates,
      isAccept,
      symbolsExternFromAlphabet,
    } = props.response;
    console.log(props.response);

    console.log(language);
    if (isAccept) {
      setAcceptanceCriteria(constants.accept[language]);
    } else {
      setAcceptanceCriteria(constants.rejects[language]);
    }

    for (let i = 0; i < tape.length; i++) {
      tape[i].final = false;
      tape[i].initial = false;

      if (props.response.initialState.name === tape[i].actualState.name) {
        tape[i].initial = true;
      }
      finalStates.forEach((element) => {
        if (element.name === tape[i].actualState.name) {
          tape[i].final = true;
        }
      });
    }
    let arraySymbolsExternAlphabetTemp = "";
    if (symbolsExternFromAlphabet != undefined) {
      for (let i = 0; i < symbolsExternFromAlphabet.length; i++) {
        const actualSymbol = symbolsExternFromAlphabet[i];
        if (!arraySymbolsExternAlphabetTemp.includes(actualSymbol)) {
          if (arraySymbolsExternAlphabetTemp.length == 0) {
            arraySymbolsExternAlphabetTemp = actualSymbol;
          } else {
            arraySymbolsExternAlphabetTemp += ", " + actualSymbol;
          }
        }
      }
      setArraySymbolsExternAlphabet(arraySymbolsExternAlphabetTemp);
    }
  }, [props.response.tape]);

  return (
    <div className="container-simulate">
      <div>
        <h3>
          {constants.word[language]}: {props.response.word}
        </h3>
        <h4>{acceptanceCriteria}</h4>
        {arraySymbolsExternAlphabet.length != 0 && (
          <h4>
            {constants.notIncludes[language]}: {arraySymbolsExternAlphabet}{" "}
          </h4>
        )}
      </div>
      {/* {props.response.tape != undefined &&
        props.response.tape.map((elTape, indexTape) => {
          return (
            <div key={indexTape} className="tape">
              {arrayWordTape != undefined &&
                arrayWordTape.map((el, index) => {
                  return (
                    <div key={index}>
                      {elTape.pos == index ||
                      (elTape.pos == arrayWordTape.length &&
                        elTape.pos - 1 == index) ? (
                        <div
                          className={`div-container-element-tape-active ${
                            elTape.pos == arrayWordTape.length &&
                            elTape.pos - 1 == index
                              ? "last-element"
                              : ""
                          }`}
                        >
                          <div className="div-state-tape">
                            {elTape.initial === true && <div>🢒</div>}
                            {elTape.final === true ? (
                              <div
                                className={`div-element-tape-state-final ${
                                  elTape.pos == arrayWordTape.length &&
                                  elTape.pos - 1 == index
                                    ? "last"
                                    : "div-element-tape-state-normal"
                                }`}
                              >
                                <div className="element-tape-state">
                                  {elTape.actualState.name}
                                </div>
                              </div>
                            ) : (
                              <div
                                className={`${
                                  elTape.pos - 1 == index
                                    ? "last"
                                    : "div-element-tape-state-normal"
                                } `}
                              >
                                <div className={`element-tape-state `}>
                                  {elTape.actualState.name}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="arrow-active-state">↓</div>

                          <div className="div-element-tape">
                            <div className="element-tape">{el}</div>
                          </div>
                        </div>
                      ) : (
                        <div className="div-element-tape">
                          <div className="element-tape">{el}</div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          );
        })} */}
    </div>
  );
};

export default SimulateAutomata;
